import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import i18n from "@/app/i18n";

export const adminUserProgressionApi = api
  .enhanceEndpoints({ addTagTypes: ["adminUserProgression"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      adminUserProgression: builder.query({
        query: ({ id }) => ({
          url: `/admin/users/${id}/get-plan-customizes`,
          method: RequestMethod.GET,
        }),
        providesTags: ["adminUserProgression"],
      }),

      assignUser: builder.mutation({
        query: ({ data }) => ({
          url: `/admin/users/training/associate`,
          method: RequestMethod.POST,
          body: data,
        }),
        invalidatesTags: ["adminUserProgression"],
      }),

      getUserPlaning: builder.query({
        query: ({ id }) => ({
          url: `/admin/users/${id}/progression`,
          method: RequestMethod.GET,
        }),
        providesTags: ["adminUserProgression"],
      }),

      getUserPlaningForPosition: builder.query({
        query: ({ position }) => ({
          url: `/admin/p-customize/position/${position}`,
          method: RequestMethod.GET,
          headers: {
            lang: i18n.language,
          },
        }),
        providesTags: ["adminUserProgression"],
      }),

      getRoutinesById: builder.query({
        query: ({ id }) => ({
          url: `/admin/p-customize/${id}`,
          method: RequestMethod.GET,
          headers: {
            lang: i18n.language,
          },
        }),
        providesTags: ["adminUserProgression"],
      }),

      getProgressionRoutine: builder.query({
        query: ({ userId }) => ({
          url: `admin/user/p-customize/duplicate-exists-plan-progression/${userId}`,
          method: RequestMethod.GET,
        }),
        providesTags: ["adminUserProgression"],
      }),

      getAlgorithmRoutines: builder.query({
        query: ({ table_name, plan_id }) => ({
          url: `/admin/algorithm/routine?table_name=${table_name}&plan_id=${plan_id}`,
          method: RequestMethod.GET,
          headers: {
            lang: i18n.language,
          },
        }),
        providesTags: ["adminUserProgression"],
      }),

      deleteRoutine: builder.mutation({
        query: ({ data }) => ({
          url: `/admin/users/training/delete`,
          method: RequestMethod.DELETE,
          body: data,
        }),
        invalidatesTags: ["adminUserProgression"],
      }),

      downloadPdf: builder.mutation({
        query: ({ data }) => ({
          url: `/admin/routines/download-pdf`,
          method: RequestMethod.POST,
          body: data,
        }),
        invalidatesTags: ["adminUserProgression"],
      }),

      gtePlanForBranch: builder.query({
        query: ({ branchId }) => ({
          url: `/admin/users/get-plan-customizes?branch_id=${branchId}`,
          method: RequestMethod.GET,
        }),
        providesTags: ["adminUserProgression"],
      }),

      createNewRoutine: builder.mutation({
        query: ({ data }) => ({
          url: `/p-customize-save-routine`,
          method: RequestMethod.POST,
          body: data,
        }),
        invalidatesTags: ["adminUserProgression"],
      }),

      saveRoutine: builder.mutation({
        query: ({ data, id }) => ({
          url: `/admin/save-routine/${id}`,
          method: RequestMethod.POST,
          body: data,
        }),
        invalidatesTags: ["adminUserProgression"],
      }),
    }),
  });

export const {
  useAdminUserProgressionQuery,
  useAssignUserMutation,
  useGetUserPlaningQuery,
  useGetRoutinesByIdQuery,
  useDeleteRoutineMutation,
  useDownloadPdfMutation,
  useGetAlgorithmRoutinesQuery,
  useGetProgressionRoutineQuery,
  useGtePlanForBranchQuery,
  useSaveRoutineMutation,
  useCreateNewRoutineMutation,
  useGetUserPlaningForPositionQuery,
} = adminUserProgressionApi;
